import React from 'react';
import './SuccessForm.css';
import StoreImage from '../../../../Assets/Forms/successform.png';
import CopyIcon from '../../../../Assets/Forms/copy.png';


const storeImg = StoreImage;


const SuccessForm = ({ onClose, enquiryId }) => {
    const displayId = enquiryId || "#FLP-8321";
    const [showCopied, setShowCopied] = React.useState(false);

    React.useEffect(() => {
        window.history.pushState({ modal: "success" }, "");
        const handlePopState = () => {
            onClose();
        };
        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, [onClose]);

    const handleCopy = () => {
        navigator.clipboard.writeText(displayId);
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
    };

    const handleGoHome = () => {
        onClose();
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
    };

    return (
        <div className="success-overlay" onClick={onClose}>
            <section className="generation-section" onClick={(e) => e.stopPropagation()}>
                <div className="success-modal-container">
                    <div className="success-modal-content">
                        <div className="success-header">
                            <div className="success-badge">
                                <div className="check-icon">✓</div>
                                <span>SUCCESS</span>
                            </div>

                            <h1 className="success-title">Enquiry Received!</h1>
                            <p className="success-description">
                                Thank you for choosing Fulupo AI. Your Enquiry about our Store keeper
                                Solution will be Successfully submitted.
                            </p>

                            <div className="enquiry-id-box">
                                <div className="enquiry-id-content">
                                    <span className="enquiry-id-label">Enquiry ID</span>
                                    <span className="enquiry-id-value">{displayId}</span>
                                </div>
                                <div className="copy-action-wrapper">
                                    {showCopied && <span className="copied-tooltip">Copied!</span>}
                                    <button
                                        className="copy-button"
                                        onClick={handleCopy}
                                        title="Copy Enquiry ID"
                                    >
                                        <img src={CopyIcon} alt="Copy" className="copy-icon" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="store-image-container">
                            <img src={storeImg} alt="Store Interior" className="store-image" />
                        </div>

                        <div className="timeline-container">
                            <div className="timeline-step active">
                                <div className="step-icon">✓</div>
                                <div className="step-info">
                                    <h3>Inquiry Sent</h3>
                                    <p>Details received successfully</p>
                                </div>
                            </div>

                            <div className="timeline-divider"></div>

                            <div className="timeline-step in-progress">
                                <div className="step-icon">⏳</div>
                                <div className="step-info">
                                    <h3>In Review</h3>
                                    <p>Our team is analyzing your store profile</p>
                                </div>
                            </div>

                            <div className="timeline-divider dotted"></div>

                            <div className="timeline-step pending">
                                <div className="step-icon">✉</div>
                                <div className="step-info">
                                    <h3>Response</h3>
                                    <p>Expected within 24–48 hours.</p>
                                </div>
                            </div>
                        </div>

                        <button className="home-button" onClick={handleGoHome}>Go to Home Page</button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SuccessForm;
